// src/components/SearchBar.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SearchBar.css';

function SearchBar() {
    const [countries, setCountries] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/data/countries-search.json`)
            .then(response => response.json())
            .then(data => setCountries(data))
            .catch(error => console.error('Error loading countries:', error));
    }, []);

    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        if (value.length > 0) {
            const filteredSuggestions = countries.filter(country =>
                country.name.toLowerCase().includes(value.toLowerCase())
            );
            setSuggestions(filteredSuggestions);
        } else {
            setSuggestions([]);
        }
    };

    const handleSuggestionClick = (code) => {
        navigate(`/travel-orb/${code}`);
        setSearchTerm('');
        setSuggestions([]);
    };

    return (
        <div className="search-container">
            <input
                type="text"
                placeholder="Search countries..."
                value={searchTerm}
                onChange={handleSearch}
                className="search-bar"
            />
            {suggestions.length > 0 && (
                <ul className="suggestions-list">
                    {suggestions.map(country => (
                        <li key={country.code} onClick={() => handleSuggestionClick(country.code)}>
                            {country.name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default SearchBar;